import parse, {HTMLReactParserOptions} from 'html-react-parser';
import {Fragment, useMemo} from 'react';

import {useClientSession} from 'hooks';

type Props<T> = {
    template: string;
    styles?: string;
    optionsProps: T;
    optionsGetter: (optionsProps: T, template: string) => HTMLReactParserOptions;
}

export type DynamicContentProps = Props<any>;

export const DynamicContent: React.FC<Props<any>> = ({template, optionsProps, optionsGetter}: Props<any>) => {
    const {localParticipant} = useClientSession();
    const options = useMemo(() => optionsGetter({...optionsProps, localParticipant}, template),
        [optionsGetter, optionsProps, template, localParticipant]);
    return (
        // eslint-disable-next-line react/jsx-no-useless-fragment
        <Fragment>{parse(template, options)}</Fragment>
    );
};
